import './styles.scss';
import { Graphic } from '../../components/graphic/index';
import bg from '../../images/bg.jpg';
import { useTheme } from '../../hooks/useTheme';
import logo from '../../images/webeix.png';
/**
 * @description Auth Form Wrapper for all auth related forms like login, signup etc
 * @type Component
 * @author Inderdeep
 */
export const AuthFormWrapper = ({ children, title, description }) => {
  const { primaryColor } = useTheme().colors;
  return (
    <>
      <div className="form-container">
        <div className="auth-form">
          <div className="logo">
            <img src={logo} />
          </div>
          {title && <p className="title">{title}</p>}
          {description && <p className="description">{description}</p>}
          {children}
        </div>
      </div>
      <Graphic reverse gradient image={bg} primaryColor={primaryColor} />
    </>
  );
};
